// TODO: jake jsou byt dalsi hodnoty?

export enum SortCode {
    Match = "MTCH",
}
